import { FC, Fragment, useMemo } from 'react';

import { GOOGLE_MAPS } from '../../constants';
import { City, Salon } from '../../model';
import { CityMarker } from './CityMarker';
import SalonMarker from './SalonMarker';
import { WorldMarker } from './WorldMarker';

type Props = {
    cities: City[];
    zoom: number;
    animatedSalonId?: string;
    onWorldMarkerClick: () => void;
    onCityMarkerClick: (city: City) => void;
    onSalonMarkerClick: (salon: Salon) => void;
    selectedCity?: City;
};

export const MapMarkers: FC<Props> = ({
    cities,
    zoom,
    animatedSalonId,
    onWorldMarkerClick,
    onCityMarkerClick,
    onSalonMarkerClick,
    selectedCity,
}) => {
    const citiesToRender = useMemo(() => {
        return cities.filter((c) => {
            if (!c.salons.length) {
                return false;
            }

            if (selectedCity) {
                return c.id === selectedCity.id;
            }

            return true;
        });
    }, [cities, selectedCity]);

    if (zoom <= GOOGLE_MAPS.zoom.world) {
        return <WorldMarker onClick={onWorldMarkerClick} />;
    }

    if (!cities?.length) {
        return null;
    }

    return (
        <>
            {citiesToRender.map((city) => (
                <Fragment key={city.id}>
                    {zoom <= GOOGLE_MAPS.zoom.map ? (
                        <CityMarker city={city} onClick={() => onCityMarkerClick(city)} />
                    ) : (
                        <>
                            {city.salons.map((salon) => (
                                <SalonMarker
                                    key={salon.id}
                                    salon={salon}
                                    onClick={() => onSalonMarkerClick(salon)}
                                    isAnimated={animatedSalonId === salon.id}
                                />
                            ))}
                        </>
                    )}
                </Fragment>
            ))}
        </>
    );
};
